<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2021-11-07 15:01:24
 * @LastEditors: Li Yong
 * @LastEditTime: 2021-11-07 16:31:55
-->
<template>
  <div class="flex flex-align-center">
    <div :class="['state_icon', row.group_status == '1' ? 'success' : 'danger']"></div>
    <div class="ml-10">{{row.group_status_name}}</div>
  </div>
</template>
<script>
import mixin from './mixin';
export default {
  mixins: [mixin]
}
</script>
<style lang="less" scoped>
.state_icon{
    width: 8px;
    height: 8px;
    border-radius: 50%;
}
.success{
    background-color: @color-success;
}
.danger{
    background-color: @color-danger;
}
</style>